<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('lead') }}
                            <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">
                                        {{ $t('vendas') }}
                                    </a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'ven-leads' })">
                                        {{ $t('leads') }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{ `${$route.params.id} - ${leadNameInner}` }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="redirectToListPage()"
                        >
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>
                <div class="select-modal">
                    <alert-container :messages="msgs" />

                    <div class="listing-header mb-4">
                        <div class="title-breadcrumb"></div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create"
                                @click="confirmarRejeicao()"
                                :disabled="
                                    isSaving ||
                                    conflito.has ||
                                    leadStatusInner == 2 ||
                                    leadStatusInner == 3
                                "
                                class="save-btn is-deny"
                                type="is-success"
                            >
                                {{ $t('rejeitar') }}
                                <button-loader :isSaving="isSavingRejeitar" />
                            </button>
                            <button
                                v-if="permissao.create"
                                @click="validateData()"
                                :disabled="isSaving || conflito.has || leadStatusInner == 3"
                                class="save-btn is-approve"
                                type="is-success"
                            >
                                {{ $t('aprovar') }}
                                <button-loader :isSaving="isSavingAprovar" />
                            </button>
                        </div>
                    </div>

                    <div v-if="conflito.has" class="notification is-danger is-light mb-2 p-2">
                        {{
                            $t('msg-configuracao-conflitante-gerenciador', {
                                n: this.$t('cliente'),
                            })
                        }}.
                        <br />
                        {{ $t('msg-favor-corrigir') }}
                        <hr class="mt-2 mb-2" />
                        <p v-if="conflito.config">
                            {{ $t('msg-conflito-config', { n: conflitoFieldConfig }) }}
                        </p>
                        <p v-if="conflito.oculto">
                            {{ $t('msg-conflito-oculto', { n: conflitoFieldOculto }) }}
                        </p>
                    </div>

                    <article
                        class="message is-danger my-4"
                        v-if="!conflito.has && clienteExistente && leadStatusInner != 3"
                    >
                        <div class="message-body">
                            <div class="icone-texto">
                                <span class="icon has-text-danger ml-0 pl-0 mr-4">
                                    <i class="fas fa-2x fa-exclamation-triangle"></i>
                                </span>
                                <span>
                                    {{
                                        this.$t('msg-cliente-ja-cadastrado', 
                                            { 
                                                nome: this.nomeClienteExistente,
                                                cnpjcpf: this.cnpjcpfClienteExistente,
                                                id: this.idClienteExistente,
                                                codigo: this.codigoClienteExistente,
                                            }
                                        )
                                    }}
                                </span>
                            </div>
                        </div>
                    </article>

                    <div
                        ref="tab-cadastrante"
                        class="tab-cadastrante page-container form-columns-fit"
                        v-if="!conflito.has"
                    >
                        <b class="mb-2">{{ $t('dados-cadastrante') }}</b>
                        <div class="columns is-flex-wrap mt-2">
                            <div class="column is-6">
                                <v-input
                                    :id="generateId(1)"
                                    :key="generateId(1)"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.cadastranteNome"
                                    title="nome"
                                    tooltipLabel="nome-cadastrante"
                                    tooltipSize="is-small"
                                    tooltipPosition="is-right"
                                    :disabled="true"
                                />
                            </div>
                            <div class="column is-6">
                                <v-input
                                    :id="generateId(2)"
                                    :key="generateId(2)"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.cadastranteCpf"
                                    title="cpf"
                                    v-mask="['###.###.###-##']"
                                    tooltipLabel="cpf-cadastrante"
                                    tooltipSize="is-small"
                                    tooltipPosition="is-right"
                                    :disabled="true"
                                />
                            </div>
                            <div class="column is-6">
                                <v-input
                                    :id="generateId(3)"
                                    :key="generateId(3)"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.cadastranteEmail"
                                    title="email"
                                    tooltipLabel="email-cadastrante"
                                    tooltipSize="is-small"
                                    tooltipPosition="is-right"
                                    :disabled="true"
                                />
                            </div>
                            <div class="column is-6">
                                <v-input
                                    :id="generateId(4)"
                                    :key="generateId(4)"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.cadastranteWhatsapp"
                                    title="ven-cliente-geral-wpp"
                                    :v-mask="['+## (##) #####-####']"
                                    tooltipLabel="whatsapp-cadastrante"
                                    tooltipSize="is-small"
                                    tooltipPosition="is-right"
                                    :disabled="true"
                                />
                            </div>
                            <div class="column is-12">
                                <hr />
                                <small class="mb-4">
                                    <b>{{ $t('financeiro-aviso-vinculo-parte-um') }}</b>
                                    {{ $t('cadastrante-warning') }}
                                </small>
                            </div>
                        </div>
                    </div>

                    <div
                        ref="tab-geral"
                        class="tab-geral page-container form-columns-fit my-4"
                        v-if="!conflito.has"
                    >
                        <div class="columns is-flex-wrap">
                            <!-- 
                            Validação de pdadetalhe: *o campo só aparece se tiver pdadetalhe configurado
                            oculta - v-if
                            label - title - disableMLtitle - tooltipLabel *se tem pdadetalhe não mostra o tooltipLabel
                            altera - disabled 
                            validchars - validchars
                            maxlength - maxlength *caso for zero, pegar na coluna no mysql
                            obrigainclusao - required - invalid *verificar no banco se é não null, se for sempre vai ser required
                            altera - disabled
                            -->
                            <div class="column is-4">
                                <vss-select
                                    :id="generateId(20)"
                                    ref="pessoaSelect"
                                    title="pessoa"
                                    :searchable="false"
                                    :options="pessoaSelect"
                                    v-model="pessoaSelected"
                                    :mlLabels="true"
                                    tooltipLabel="informacao-cliente-tipocliente"
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :disabled="true"
                                    @onBlurFunction="sendIsChanged()"
                                />
                            </div>
                            <div
                                class="column is-4"
                                v-if="
                                    pdadetalhe['estrangeiro'] && !pdadetalhe['estrangeiro'].oculta
                                "
                            >
                                <vss-select
                                    :id="generateId(30)"
                                    ref="estrangeiro"
                                    :title="
                                        !isNull(pdadetalhe['estrangeiro'].label)
                                            ? pdadetalhe['estrangeiro'].label
                                            : 'cliente-estrangeiro'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['estrangeiro'].label)"
                                    :msg="pdadetalhe['estrangeiro'].msg"
                                    :invalid="false"
                                    :required="false"
                                    :searchable="false"
                                    :options="estrangeiroSelect"
                                    v-model="estrangeiroSelected"
                                    :mlLabels="true"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['estrangeiro'].label)
                                            ? 'informacao-cliente-estrangeiro'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :disabled="true"
                                />
                            </div>
                            <!-- 
                            Mudanças de campos dependendo da seleção de pessoa cliente.TIPOCLIENTE (0: físico ou 1: jurídico) e cliente.ESTRANGEIRO (1: sim ou 0: não)
                            pessoa=0 e estrangeiro=0 | cnpjcpf: CPF, ierg: RG, datanascimento: Data de nascimento, cep: CEP
                            pessoa=1 e estrangeiro=0 | cnpjcpf: CNPJ, ierg: Inscrição estadual, datanascimento: Data de fundação, cep: CEP
                            pessoa=0 e estrangeiro=1 | cnpjcpf: CI, ierg: não mostra, datanascimento: Data de nascimento, cep: CEP Estrangeiro
                            pessoa=1 e estrangeiro=1 | cnpjcpf: RUC, ierg: não mostra, datanascimento: Data de fundação, cep: CEP Estrangeiro
                            Na edição, os campos tipo de pessoa e cliente estrangeiro devem ficar bloqueados para edição.
                            -->
                            <!-- start cnpjcpf ------------------------------------------------------------ -->
                            <div
                                class="column is-4"
                                v-if="
                                    pessoaSelected.id == 1 &&
                                    estrangeiroSelected.id == 0 &&
                                    pdadetalhe['cnpjcpf'] &&
                                    !pdadetalhe['cnpjcpf'].oculta
                                "
                            >
                                <v-input
                                    :id="generateId(70)"
                                    :key="generateId(70)"
                                    ref="cnpjcpf"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.cnpjcpf"
                                    :title="
                                        !isNull(pdadetalhe['cnpjcpf'].label)
                                            ? pdadetalhe['cnpjcpf'].label
                                            : 'cnpj'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['cnpjcpf'].label)"
                                    placeholder="cnpj-do-cliente-placeholder"
                                    :msg="pdadetalhe['cnpjcpf'].msg"
                                    :invalid="pdadetalhe['cnpjcpf'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('cnpjcpf')"
                                    v-mask="['##.###.###/####-##']"
                                    :required="!clienteExistente"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['cnpjcpf'].label)
                                            ? 'informacao-cliente-cnpj-sem-lupa'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-right"
                                    :disabled="true"
                                />
                            </div>
                            <div
                                class="column is-4"
                                v-else-if="
                                    pessoaSelected.id == 0 &&
                                    estrangeiroSelected.id == 0 &&
                                    pdadetalhe['cnpjcpf'] &&
                                    !pdadetalhe['cnpjcpf'].oculta
                                "
                            >
                                <v-input
                                    :id="generateId(80)"
                                    :key="generateId(80)"
                                    ref="cnpjcpf"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.cnpjcpf"
                                    :title="
                                        !isNull(pdadetalhe['cnpjcpf'].label)
                                            ? pdadetalhe['cnpjcpf'].label
                                            : 'cpf'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['cnpjcpf'].label)"
                                    placeholder="cpf-do-cliente-placeholder"
                                    :msg="pdadetalhe['cnpjcpf'].msg"
                                    :invalid="pdadetalhe['cnpjcpf'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('cnpjcpf')"
                                    :useMask="true"
                                    :vMask="['###.###.###-##']"
                                    :required="!clienteExistente"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['cnpjcpf'].label)
                                            ? 'informacao-cliente-cpf'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-right"
                                    :disabled="true"
                                />
                            </div>
                            <div
                                class="column is-4"
                                v-else-if="
                                    pessoaSelected.id == 0 &&
                                    estrangeiroSelected.id == 1 &&
                                    pdadetalhe['cnpjcpf'] &&
                                    !pdadetalhe['cnpjcpf'].oculta
                                "
                            >
                                <v-input
                                    :id="generateId(81)"
                                    :key="generateId(81)"
                                    ref="cnpjcpf"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.cnpjcpf"
                                    :title="
                                        !isNull(pdadetalhe['cnpjcpf'].label)
                                            ? pdadetalhe['cnpjcpf'].label
                                            : 'ci'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['cnpjcpf'].label)"
                                    placeholder="cpf-do-cliente-placeholder"
                                    :msg="pdadetalhe['cnpjcpf'].msg"
                                    :invalid="pdadetalhe['cnpjcpf'].invalid"
                                    :required="!clienteExistente"
                                    @onBlurFunction="validadeByPdaDetalhe('cnpjcpf')"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['cnpjcpf'].label)
                                            ? 'informacao-cliente-ci'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-right"
                                    :disabled="true"
                                    :validchars="pdadetalhe['cnpjcpf'].validchars"
                                    :maxlength="
                                        pdadetalhe['cnpjcpf'].maxlength > 0
                                            ? pdadetalhe['cnpjcpf'].maxlength
                                            : 20
                                    "
                                />
                            </div>
                            <div
                                class="column is-4"
                                v-else-if="
                                    pessoaSelected.id == 1 &&
                                    estrangeiroSelected.id == 1 &&
                                    pdadetalhe['cnpjcpf'] &&
                                    !pdadetalhe['cnpjcpf'].oculta
                                "
                            >
                                <v-input
                                    :id="generateId(82)"
                                    :key="generateId(82)"
                                    ref="cnpjcpf"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.cnpjcpf"
                                    :title="
                                        !isNull(pdadetalhe['cnpjcpf'].label)
                                            ? pdadetalhe['cnpjcpf'].label
                                            : 'ruc'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['cnpjcpf'].label)"
                                    placeholder="cpf-do-cliente-placeholder"
                                    :msg="pdadetalhe['cnpjcpf'].msg"
                                    :invalid="pdadetalhe['cnpjcpf'].invalid"
                                    :required="!clienteExistente"
                                    @onBlurFunction="validadeByPdaDetalhe('cnpjcpf')"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['cnpjcpf'].label)
                                            ? 'informacao-cliente-ruc'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-right"
                                    :disabled="true"
                                    :validchars="pdadetalhe['cnpjcpf'].validchars"
                                    :maxlength="
                                        pdadetalhe['cnpjcpf'].maxlength > 0
                                            ? pdadetalhe['cnpjcpf'].maxlength
                                            : 20
                                    "
                                />
                            </div>
                            <!-- end cnpjcpf -------------------------------------------------------------- -->
                            <div
                                class="column is-4"
                                v-if="pdadetalhe['nome'] && !pdadetalhe['nome'].oculta"
                            >
                                <v-input
                                    :id="generateId(50)"
                                    ref="nome"
                                    v-model="cliente.nome"
                                    placeholder="placeholder-preencha"
                                    :title="
                                        !isNull(pdadetalhe['nome'].label)
                                            ? pdadetalhe['nome'].label
                                            : 'nome'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['nome'].label)"
                                    :msg="pdadetalhe['nome'].msg"
                                    :invalid="pdadetalhe['nome'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('nome')"
                                    :required="!clienteExistente"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['nome'].label)
                                            ? 'informacao-cliente-nome'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :validchars="pdadetalhe['nome'].validchars"
                                    :maxlength="
                                        pdadetalhe['nome'].maxlength > 0
                                            ? pdadetalhe['nome'].maxlength
                                            : 255
                                    "
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div
                                class="column is-4"
                                v-if="pdadetalhe['rsocial'] && !pdadetalhe['rsocial'].oculta"
                            >
                                <v-input
                                    :id="generateId(60)"
                                    ref="rsocial"
                                    v-model="cliente.rsocial"
                                    placeholder="placeholder-preencha"
                                    :title="
                                        !isNull(pdadetalhe['rsocial'].label)
                                            ? pdadetalhe['rsocial'].label
                                            : pessoaSelected.id == 1
                                            ? 'razaosocial'
                                            : 'sobrenome'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['rsocial'].label)"
                                    :invalid="pdadetalhe['rsocial'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('rsocial')"
                                    :required="
                                        pdadetalhe['rsocial'].obrigainclusao && !clienteExistente
                                    "
                                    :msg="pdadetalhe['rsocial'].msg"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['rsocial'].label)
                                            ? pessoaSelected.id == 1
                                                ? 'informacao-cliente-rsocial'
                                                : 'informacao-cliente-sobrenome'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :validchars="pdadetalhe['rsocial'].validchars"
                                    :maxlength="
                                        pdadetalhe['rsocial'].maxlength > 0
                                            ? pdadetalhe['rsocial'].maxlength
                                            : 255
                                    "
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <!-- Caso mude o cadastro para pessoa física, caso oculte o campo ierg ou caso não tenha ativo o modulopdadetalhe de ierg,
                            o campo cliente.contribuinte recebe o valor de 'null' e deixa de aparecer -->
                            <div
                                class="column is-4"
                                v-if="
                                    pessoaSelected.id == 1 &&
                                    estrangeiroSelected.id == 0 &&
                                    pdadetalhe['ierg'] &&
                                    !pdadetalhe['ierg'].oculta
                                "
                            >
                                <vss-select
                                    :id="generateId(89)"
                                    ref="contribuinte"
                                    title="contribuinte"
                                    :searchable="false"
                                    :options="contribuinteSelect"
                                    v-model="contribuinteSelected"
                                    :mlLabels="true"
                                    @onBlurFunction="sendIsChanged()"
                                    tooltipLabel="informacao-cliente-contribuinte"
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <!-- start ierg --------------------------------------------------------------- -->
                            <div
                                class="column is-4"
                                v-if="
                                    pessoaSelected.id == 1 &&
                                    estrangeiroSelected.id == 0 &&
                                    pdadetalhe['ierg'] &&
                                    !pdadetalhe['ierg'].oculta &&
                                    contribuinteSelected.id != 'I'
                                "
                            >
                                <!-- validchars manualmente, pois não bate com as regras do mobile -->
                                <v-input
                                    :id="generateId(90)"
                                    :key="generateId(90)"
                                    ref="ierg"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.ierg"
                                    placeholder="placeholder-preencha"
                                    :title="
                                        !isNull(pdadetalhe['ierg'].label)
                                            ? pdadetalhe['ierg'].label
                                            : 'ie'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['ierg'].label)"
                                    :msg="pdadetalhe['ierg'].msg"
                                    :invalid="pdadetalhe['ierg'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('ierg')"
                                    :required="
                                        pdadetalhe['ierg'].obrigainclusao && !clienteExistente
                                    "
                                    :tooltipLabel="
                                        isNull(pdadetalhe['ierg'].label)
                                            ? 'informacao-cliente-ie'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    validchars="0123456789-."
                                    :maxlength="
                                        pdadetalhe['ierg'].maxlength > 0
                                            ? pdadetalhe['ierg'].maxlength
                                            : 20
                                    "
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div
                                class="column is-4"
                                v-if="
                                    pessoaSelected.id == 1 &&
                                    estrangeiroSelected.id == 0 &&
                                    pdadetalhe['ierg'] &&
                                    !pdadetalhe['ierg'].oculta &&
                                    contribuinteSelected.id == 'I'
                                "
                            >
                                <v-input
                                    :id="generateId(90)"
                                    :key="generateId(90)"
                                    ref="ierg"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.ierg"
                                    :title="
                                        !isNull(pdadetalhe['ierg'].label)
                                            ? pdadetalhe['ierg'].label
                                            : 'ie'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['ierg'].label)"
                                    :msg="pdadetalhe['ierg'].msg"
                                    :invalid="pdadetalhe['ierg'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('ierg')"
                                    :required="
                                        pdadetalhe['ierg'].obrigainclusao && !clienteExistente
                                    "
                                    :tooltipLabel="
                                        isNull(pdadetalhe['ierg'].label)
                                            ? 'informacao-cliente-ie'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :disabled="true"
                                />
                            </div>
                            <div
                                class="column is-4"
                                v-if="
                                    pessoaSelected.id == 0 &&
                                    estrangeiroSelected.id == 0 &&
                                    pdadetalhe['ierg'] &&
                                    !pdadetalhe['ierg'].oculta
                                "
                            >
                                <v-input
                                    :id="generateId(91)"
                                    :key="generateId(91)"
                                    ref="ierg"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.ierg"
                                    placeholder="placeholder-preencha"
                                    :maxlength="50"
                                    :title="
                                        !isNull(pdadetalhe['ierg'].label)
                                            ? pdadetalhe['ierg'].label
                                            : 'rg'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['ierg'].label)"
                                    :msg="pdadetalhe['ierg'].msg"
                                    :invalid="pdadetalhe['ierg'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('ierg')"
                                    :required="
                                        pdadetalhe['ierg'].obrigainclusao && !clienteExistente
                                    "
                                    :tooltipLabel="
                                        isNull(pdadetalhe['ierg'].label)
                                            ? 'informacao-cliente-rg'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <!-- end ierg ----------------------------------------------------------------- -->
                            <div
                                class="column is-4"
                                v-if="
                                    pdadetalhe['datanascimento'] &&
                                    !pdadetalhe['datanascimento'].oculta
                                "
                            >
                                <verified-date-picker
                                    :id="generateId(40)"
                                    ref="datanascimento"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="dataNascimento"
                                    placeholder="selecione-uma-data"
                                    :title="
                                        !isNull(pdadetalhe['datanascimento'].label)
                                            ? pdadetalhe['datanascimento'].label
                                            : pessoaSelected.id == 0
                                            ? 'data-nascimento'
                                            : 'data-fundacao'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['datanascimento'].label)"
                                    :required="
                                        pdadetalhe['datanascimento'].obrigainclusao &&
                                        !clienteExistente
                                    "
                                    :invalid="pdadetalhe['datanascimento'].invalid"
                                    @onBlurFunction="sendIsChanged('datanascimento')"
                                    :msg="pdadetalhe['datanascimento'].msg"
                                    :subtractDateYears="80"
                                    :yearsRange="[-50, 50]"
                                    :inForm="true"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['datanascimento'].label)
                                            ? pessoaSelected.id == 0
                                                ? 'informacao-cliente-datanascimento'
                                                : 'informacao-cliente-datafuncacao'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div class="column is-4">
                                <vss-select
                                    :id="generateId(41)"
                                    ref="vendedor"
                                    :title="'vendedor'"
                                    :msg="vendedor.msg"
                                    :invalid="vendedor.invalid"
                                    :required="leadStatusInner != 3"
                                    clearable
                                    searchable
                                    @search="loadVendedores($event)"
                                    :options="vendedorSelect"
                                    v-model="vendedorSelected"
                                    :mlLabels="false"
                                    :tooltipLabel="'informacao-cliente-vendedor'"
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    @onBlurFunction="sendIsChanged('vendedor')"
                                    :disabled="leadStatusInner == 3"
                                />
                            </div>
                            <div
                                class="column is-4"
                                v-if="pdadetalhe['regiao'] && !pdadetalhe['regiao'].oculta"
                            >
                                <div class="field has-addons">
                                    <div class="control is-expanded">
                                        <vss-select
                                            :id="generateId(42)"
                                            ref="regiao"
                                            :title="
                                                !isNull(pdadetalhe['regiao'].label)
                                                    ? pdadetalhe['regiao'].label
                                                    : 'regiao'
                                            "
                                            :disableMLtitle="!isNull(pdadetalhe['regiao'].label)"
                                            :msg="pdadetalhe['regiao'].msg"
                                            :invalid="pdadetalhe['regiao'].invalid"
                                            :required="
                                                pdadetalhe['regiao'].obrigainclusao &&
                                                !clienteExistente
                                            "
                                            :clearable="!pdadetalhe['regiao'].obrigainclusao"
                                            :searchable="false"
                                            :options="regiaoSelect"
                                            v-model="regiaoSelected"
                                            :mlLabels="false"
                                            :tooltipLabel="
                                                isNull(pdadetalhe['regiao'].label)
                                                    ? 'informacao-cliente-regiao'
                                                    : null
                                            "
                                            tooltipSize="is-small"
                                            tooltipPosition="is-top"
                                            @onBlurFunction="sendIsChanged('regiao')"
                                            :disabled="clienteExistente"
                                        />
                                    </div>
                                    <div
                                        v-if="!clienteExistente"
                                        class="control padding-label padding-label-custom"
                                    >
                                        <b-button
                                            @click="showModalCadastroRegiao = true"
                                            icon-right="plus"
                                            v-tippy
                                            :title="$t('adicionar') + ' ' + $t('regiao')"
                                        />
                                    </div>
                                </div>
                                <b-modal :active.sync="showModalCadastroRegiao">
                                    <div>
                                        <RegiaoCadastroModal
                                            v-if="showModalCadastroRegiao"
                                            @fecharModal="fecharModalRegiaoWithValue($event)"
                                        />
                                    </div>
                                </b-modal>
                            </div>
                            <div
                                class="column is-4"
                                v-if="pdadetalhe['atividade'] && !pdadetalhe['atividade'].oculta"
                            >
                                <vss-select
                                    :id="generateId(43)"
                                    ref="atividade"
                                    :title="
                                        !isNull(pdadetalhe['atividade'].label)
                                            ? pdadetalhe['atividade'].label
                                            : 'atividade'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['atividade'].label)"
                                    :msg="pdadetalhe['atividade'].msg"
                                    :invalid="pdadetalhe['atividade'].invalid"
                                    :required="
                                        pdadetalhe['atividade'].obrigainclusao && !clienteExistente
                                    "
                                    :clearable="!pdadetalhe['atividade'].obrigainclusao"
                                    :options="atividadeSelect"
                                    v-model="atividadeSelected"
                                    :searchable="true"
                                    @search="loadAtividades($event)"
                                    :mlLabels="false"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['atividade'].label)
                                            ? 'informacao-cliente-atividade'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    @onBlurFunction="sendIsChanged('atividade')"
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div
                                class="column is-4"
                                v-if="pdadetalhe['ramo'] && !pdadetalhe['ramo'].oculta"
                            >
                                <vss-select
                                    :id="generateId(42)"
                                    ref="ramo"
                                    :title="
                                        !isNull(pdadetalhe['ramo'].label)
                                            ? pdadetalhe['ramo'].label
                                            : 'ramo-atuacao'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['ramo'].label)"
                                    :msg="pdadetalhe['ramo'].msg"
                                    :invalid="pdadetalhe['ramo'].invalid"
                                    :required="
                                        pdadetalhe['ramo'].obrigainclusao && !clienteExistente
                                    "
                                    :clearable="!pdadetalhe['ramo'].obrigainclusao"
                                    :searchable="false"
                                    :options="ramoSelect"
                                    v-model="ramoSelected"
                                    :mlLabels="false"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['ramo'].label)
                                            ? 'informacao-cliente-ramo'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    @onBlurFunction="sendIsChanged('ramo')"
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div
                                class="column is-4"
                                v-if="pdadetalhe['matriz'] && !pdadetalhe['matriz'].oculta"
                            >
                                <vss-select
                                    :id="generateId(43)"
                                    ref="matriz"
                                    :title="
                                        !isNull(pdadetalhe['matriz'].label)
                                            ? pdadetalhe['matriz'].label
                                            : 'matriz'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['matriz'].label)"
                                    :msg="pdadetalhe['matriz'].msg"
                                    :invalid="pdadetalhe['matriz'].invalid"
                                    :required="
                                        pdadetalhe['matriz'].obrigainclusao && !clienteExistente
                                    "
                                    :clearable="!pdadetalhe['matriz'].obrigainclusao"
                                    :searchable="false"
                                    :options="matrizSelect"
                                    v-model="matrizSelected"
                                    :mlLabels="false"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['matriz'].label)
                                            ? 'informacao-cliente-matriz'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    @onBlurFunction="sendIsChanged('matriz')"
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <!-- @86164 - situação definida como obrigatória para cadastros vindos do B2B -->
                            <div
                                class="column is-4"
                                v-if="pdadetalhe['situacao'] && !pdadetalhe['situacao'].oculta"
                            >
                                <div class="field has-addons">
                                    <div class="control is-expanded">
                                        <vss-select
                                            :id="generateId(42)"
                                            ref="situacao"
                                            :title="
                                                !isNull(pdadetalhe['situacao'].label)
                                                    ? pdadetalhe['situacao'].label
                                                    : 'situacao-cadastral'
                                            "
                                            :disableMLtitle="!isNull(pdadetalhe['situacao'].label)"
                                            :msg="pdadetalhe['situacao'].msg"
                                            :invalid="pdadetalhe['situacao'].invalid"
                                            :required="!clienteExistente"
                                            :clearable="false"
                                            :searchable="false"
                                            :options="situacaoSelect"
                                            v-model="situacaoSelected"
                                            :mlLabels="false"
                                            :tooltipLabel="
                                                isNull(pdadetalhe['situacao'].label)
                                                    ? 'informacao-cliente-situacao'
                                                    : null
                                            "
                                            tooltipSize="is-small"
                                            tooltipPosition="is-top"
                                            @onBlurFunction="sendIsChanged('situacao')"
                                            :disabled="clienteExistente"
                                        />
                                    </div>
                                    <div
                                        v-if="!clienteExistente"
                                        class="control padding-label padding-label-custom"
                                    >
                                        <b-button
                                            @click="showModalCadastroSituacao = true"
                                            icon-right="plus"
                                            v-tippy
                                            :title="$t('adicionar') + ' ' + $t('situacao-cliente')"
                                        />
                                    </div>
                                </div>
                                <b-modal :active.sync="showModalCadastroSituacao">
                                    <div>
                                        <SituacaoCadastroModal
                                            v-if="showModalCadastroSituacao"
                                            @fecharModal="fecharModalSituacaoWithValue($event)"
                                        />
                                    </div>
                                </b-modal>
                            </div>
                            <div
                                class="column is-4"
                                v-if="
                                    pdadetalhe['transportadora'] &&
                                    !pdadetalhe['transportadora'].oculta
                                "
                            >
                                <vss-select
                                    :id="generateId(42)"
                                    ref="transportadora"
                                    :title="
                                        !isNull(pdadetalhe['transportadora'].label)
                                            ? pdadetalhe['transportadora'].label
                                            : 'transportadora-padrao'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['transportadora'].label)"
                                    :msg="pdadetalhe['transportadora'].msg"
                                    :invalid="pdadetalhe['transportadora'].invalid"
                                    :clearable="
                                        !pdadetalhe['transportadora'].obrigainclusao &&
                                        !clienteExistente
                                    "
                                    :required="
                                        pdadetalhe['transportadora'].obrigainclusao &&
                                        !clienteExistente
                                    "
                                    :searchable="false"
                                    :options="transportadoraSelect"
                                    v-model="transportadoraSelected"
                                    :mlLabels="false"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['transportadora'].label)
                                            ? 'informacao-cliente-transportadora'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    @onBlurFunction="sendIsChanged('transportadora')"
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div
                                class="column is-4"
                                v-if="
                                    pdadetalhe['grupoeconomico'] &&
                                    !pdadetalhe['grupoeconomico'].oculta
                                "
                            >
                                <div class="field has-addons">
                                    <div class="control is-expanded">
                                        <vss-select
                                            :id="generateId(42)"
                                            ref="grupoeconomico"
                                            :title="
                                                !isNull(pdadetalhe['grupoeconomico'].label)
                                                    ? pdadetalhe['grupoeconomico'].label
                                                    : 'grupoeconomico'
                                            "
                                            :disableMLtitle="
                                                !isNull(pdadetalhe['grupoeconomico'].label)
                                            "
                                            :msg="pdadetalhe['grupoeconomico'].msg"
                                            :invalid="pdadetalhe['grupoeconomico'].invalid"
                                            :clearable="
                                                !pdadetalhe['grupoeconomico'].obrigainclusao &&
                                                !clienteExistente
                                            "
                                            :required="
                                                pdadetalhe['grupoeconomico'].obrigainclusao &&
                                                !clienteExistente
                                            "
                                            :searchable="false"
                                            :options="grupoEconomicoSelect"
                                            v-model="grupoEconomicoSelected"
                                            :mlLabels="false"
                                            :tooltipLabel="
                                                isNull(pdadetalhe['grupoeconomico'].label)
                                                    ? 'informacao-cliente-grupoeconomico'
                                                    : null
                                            "
                                            tooltipSize="is-small"
                                            tooltipPosition="is-top"
                                            @onBlurFunction="sendIsChanged('grupoeconomico')"
                                            :disabled="clienteExistente"
                                        />
                                    </div>
                                    <div
                                        class="control padding-label padding-label-custom"
                                        v-if="hasGrupoEconomicoPermission && !clienteExistente"
                                    >
                                        <b-button
                                            @click="showModalCadastroGrupoEconomico = true"
                                            icon-right="plus"
                                            v-tippy
                                            :title="$t('adicionar') + ' ' + $t('grupoeconomico')"
                                        />
                                    </div>
                                    <b-modal :active.sync="showModalCadastroGrupoEconomico">
                                        <div>
                                            <GrupoEconomicoCadastroModal
                                                v-if="showModalCadastroGrupoEconomico"
                                                @fecharModal="fecharModalGrupoEconomico($event)"
                                            />
                                        </div>
                                    </b-modal>
                                </div>
                            </div>
                            <!-- @84474 - Inserido campo de tipo de consumidor -->
                            <div class="column is-4">
                                <vss-select
                                    :id="generateId(21)"
                                    ref="tipoconsumidor"
                                    title="tipo-consumidor"
                                    :searchable="false"
                                    :options="tipoConsumidorSelect"
                                    v-model="tipoConsumidorSelected"
                                    :mlLabels="true"
                                    tooltipLabel="informacao-cliente-tipoconsumidor"
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    @onBlurFunction="sendIsChanged()"
                                    :disabled="clienteExistente"
                                />
                            </div>
                        </div>
                        <VerifiedConfigExtra
                            v-if="showConfigExtra"
                            tabela="cliente"
                            :extra="extra"
                            :isUpdate="true"
                            :checkValidations="checkValidations"
                            @validating="checkValidations = $event"
                            @onChange="changeValConfigExtra($event)"
                            @hasExtra="hasExtra.geral = $event"
                            aba="geral"
                            :cantEdit="clienteExistente"
                            :isRequired="!clienteExistente"
                        />
                    </div>
                    <div
                        ref="tab-endereco"
                        class="tab-endereco page-container form-columns-fit mt-4 mb-4"
                        v-if="!conflito.has"
                        v-show="hasFields.endereco || hasExtra.endereco"
                    >
                        <div class="columns is-flex-wrap">
                            <!-- start cep --------------------------------------------------------------- -->
                            <div
                                class="column is-3"
                                :class="{ loading: isSearchingCEP }"
                                v-if="
                                    pdadetalhe['cep'] &&
                                    !pdadetalhe['cep'].oculta &&
                                    (estrangeiroSelected.id == 0 ||
                                        (estrangeiroSelected.id == 1 &&
                                            isNull(pdadetalhe['cepestrangeiro'])))
                                "
                            >
                                <v-input
                                    :id="generateId(100)"
                                    :key="generateId(100)"
                                    ref="cep"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.cep"
                                    :title="
                                        !isNull(pdadetalhe['cep'].label)
                                            ? pdadetalhe['cep'].label
                                            : 'cep-do-cliente'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['cep'].label)"
                                    placeholder="cep-do-cliente-placeholder"
                                    :msg="pdadetalhe['cep'].msg"
                                    :invalid="pdadetalhe['cep'].invalid"
                                    :required="
                                        pdadetalhe['cep'].obrigainclusao && !clienteExistente
                                    "
                                    @onBlurFunction="validadeByPdaDetalhe('cep')"
                                    :useMask="true"
                                    :vMask="['##.###-###']"
                                    :icon="clienteExistente ? '' : 'magnify'"
                                    @input-action="getInfoByCEP"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['cep'].label)
                                            ? 'informacao-cliente-cep'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <!-- Quando for estrangeiro, se tiver o campo cepestrangeiro em modulopdadetalhe a apresentação segue o modulopdadetalhe -->
                            <div
                                class="column is-3"
                                v-else-if="
                                    pdadetalhe['cep'] &&
                                    pdadetalhe['cepestrangeiro'] &&
                                    !pdadetalhe['cepestrangeiro'].oculta
                                "
                            >
                                <v-input
                                    :id="generateId(101)"
                                    :key="generateId(101)"
                                    ref="cepestrangeiro"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.cep"
                                    placeholder="cep-do-cliente-placeholder"
                                    :title="
                                        !isNull(pdadetalhe['cepestrangeiro'].label)
                                            ? pdadetalhe['cepestrangeiro'].label
                                            : 'cepestrangeiro'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['cepestrangeiro'].label)"
                                    :msg="pdadetalhe['cepestrangeiro'].msg"
                                    :invalid="pdadetalhe['cepestrangeiro'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('cepestrangeiro')"
                                    :required="
                                        pdadetalhe['cepestrangeiro'].obrigainclusao &&
                                        !clienteExistente
                                    "
                                    :validchars="pdadetalhe['cepestrangeiro'].validchars"
                                    :maxlength="
                                        pdadetalhe['cepestrangeiro'].maxlength > 0
                                            ? pdadetalhe['cepestrangeiro'].maxlength
                                            : 10
                                    "
                                    :tooltipLabel="
                                        isNull(pdadetalhe['cepestrangeiro'].label)
                                            ? 'informacao-cliente-cepestrangeiro'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <!-- end cep ----------------------------------------------------------------- -->
                            <div
                                class="column is-4"
                                v-if="pdadetalhe['cidade'] && !pdadetalhe['cidade'].oculta"
                            >
                                <vss-select
                                    :id="generateId(110)"
                                    ref="cidade"
                                    label="nome"
                                    v-model="cidadeSelected"
                                    placeholder="selecione"
                                    :title="
                                        !isNull(pdadetalhe['cidade'].label)
                                            ? pdadetalhe['cidade'].label
                                            : 'cidade'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['cidade'].label)"
                                    :options="cidadeSelect"
                                    :msg="pdadetalhe['cidade'].msg"
                                    :invalid="pdadetalhe['cidade'].invalid"
                                    searchable
                                    @search="loadCidade"
                                    :required="
                                        pdadetalhe['cidade'].obrigainclusao && !clienteExistente
                                    "
                                    :tooltipLabel="
                                        isNull(pdadetalhe['cidade'].label)
                                            ? 'informacao-cliente-cidade'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    @onBlurFunction="sendIsChanged('cidade'), updateCidade()"
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div
                                class="column is-5"
                                v-if="pdadetalhe['bairro'] && !pdadetalhe['bairro'].oculta"
                            >
                                <v-input
                                    :id="generateId(120)"
                                    ref="bairro"
                                    v-model="cliente.bairro"
                                    placeholder="placeholder-preencha"
                                    :title="
                                        !isNull(pdadetalhe['bairro'].label)
                                            ? pdadetalhe['bairro'].label
                                            : 'bairro'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['bairro'].label)"
                                    :msg="pdadetalhe['bairro'].msg"
                                    :invalid="pdadetalhe['bairro'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('bairro')"
                                    :required="
                                        pdadetalhe['bairro'].obrigainclusao && !clienteExistente
                                    "
                                    :tooltipLabel="
                                        isNull(pdadetalhe['bairro'].label)
                                            ? 'informacao-cliente-bairro'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :validchars="pdadetalhe['bairro'].validchars"
                                    :maxlength="
                                        pdadetalhe['bairro'].maxlength > 0
                                            ? pdadetalhe['bairro'].maxlength
                                            : 50
                                    "
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div
                                class="column is-9"
                                v-if="pdadetalhe['endereco'] && !pdadetalhe['endereco'].oculta"
                            >
                                <v-input
                                    :id="generateId(130)"
                                    ref="endereco"
                                    v-model="cliente.endereco"
                                    placeholder="placeholder-preencha"
                                    :title="
                                        !isNull(pdadetalhe['endereco'].label)
                                            ? pdadetalhe['endereco'].label
                                            : 'endereco'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['endereco'].label)"
                                    :msg="pdadetalhe['endereco'].msg"
                                    :invalid="pdadetalhe['endereco'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('endereco')"
                                    :required="
                                        pdadetalhe['endereco'].obrigainclusao && !clienteExistente
                                    "
                                    :tooltipLabel="
                                        isNull(pdadetalhe['endereco'].label)
                                            ? 'informacao-cliente-endereco'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :validchars="pdadetalhe['endereco'].validchars"
                                    :maxlength="
                                        pdadetalhe['endereco'].maxlength > 0
                                            ? pdadetalhe['endereco'].maxlength
                                            : 50
                                    "
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div
                                class="column is-3"
                                v-if="pdadetalhe['numero'] && !pdadetalhe['numero'].oculta"
                            >
                                <v-input
                                    :id="generateId(140)"
                                    ref="numero"
                                    v-model="cliente.numero"
                                    placeholder="placeholder-preencha"
                                    :title="
                                        !isNull(pdadetalhe['numero'].label)
                                            ? pdadetalhe['numero'].label
                                            : 'numero'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['numero'].label)"
                                    :msg="pdadetalhe['numero'].msg"
                                    :invalid="pdadetalhe['numero'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('numero')"
                                    :required="
                                        pdadetalhe['numero'].obrigainclusao && !clienteExistente
                                    "
                                    :useMask="
                                        isNull(pdadetalhe['numero'].validchars) ||
                                        (!isNull(pdadetalhe['numero'].validchars) &&
                                            onlyNumbers(pdadetalhe['numero'].validchars))
                                    "
                                    :vMask="['##########']"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['numero'].label)
                                            ? 'informacao-cliente-numero'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :validchars="pdadetalhe['numero'].validchars"
                                    :maxlength="
                                        pdadetalhe['numero'].maxlength > 0
                                            ? pdadetalhe['numero'].maxlength
                                            : 15
                                    "
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div
                                class="column is-12"
                                v-if="
                                    pdadetalhe['complemento'] && !pdadetalhe['complemento'].oculta
                                "
                            >
                                <v-input
                                    :id="generateId(141)"
                                    ref="complemento"
                                    v-model="cliente.complemento"
                                    placeholder="placeholder-preencha"
                                    :title="
                                        !isNull(pdadetalhe['complemento'].label)
                                            ? pdadetalhe['complemento'].label
                                            : 'complemento'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['complemento'].label)"
                                    :msg="pdadetalhe['complemento'].msg"
                                    :invalid="pdadetalhe['complemento'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('complemento')"
                                    :required="
                                        pdadetalhe['complemento'].obrigainclusao &&
                                        !clienteExistente
                                    "
                                    :tooltipLabel="
                                        isNull(pdadetalhe['complemento'].label)
                                            ? 'informacao-cliente-complemento'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :validchars="pdadetalhe['complemento'].validchars"
                                    :maxlength="
                                        pdadetalhe['complemento'].maxlength > 0
                                            ? pdadetalhe['complemento'].maxlength
                                            : 50
                                    "
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div
                                class="column is-6"
                                v-if="pdadetalhe['latitude'] && !pdadetalhe['latitude'].oculta"
                            >
                                <v-input
                                    :id="generateId(150)"
                                    ref="latitude"
                                    v-model="cliente.latitude"
                                    placeholder="placeholder-preencha"
                                    :title="
                                        !isNull(pdadetalhe['latitude'].label)
                                            ? pdadetalhe['latitude'].label
                                            : 'latitude'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['latitude'].label)"
                                    :msg="pdadetalhe['latitude'].msg"
                                    :invalid="pdadetalhe['latitude'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('latitude')"
                                    :required="
                                        pdadetalhe['latitude'].obrigainclusao && !clienteExistente
                                    "
                                    :tooltipLabel="
                                        isNull(pdadetalhe['latitude'].label)
                                            ? 'informacao-cliente-latitude'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :maxlength="50"
                                    validchars="0123456789-."
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div
                                class="column is-6"
                                v-if="pdadetalhe['longitude'] && !pdadetalhe['longitude'].oculta"
                            >
                                <div class="field has-addons">
                                    <div class="control is-expanded">
                                        <v-input
                                            :id="generateId(160)"
                                            ref="longitude"
                                            v-model="cliente.longitude"
                                            placeholder="placeholder-preencha"
                                            :title="
                                                !isNull(pdadetalhe['longitude'].label)
                                                    ? pdadetalhe['longitude'].label
                                                    : 'longitude'
                                            "
                                            :disableMLtitle="!isNull(pdadetalhe['longitude'].label)"
                                            :msg="pdadetalhe['longitude'].msg"
                                            :invalid="pdadetalhe['longitude'].invalid"
                                            @onBlurFunction="validadeByPdaDetalhe('longitude')"
                                            :required="
                                                pdadetalhe['longitude'].obrigainclusao &&
                                                !clienteExistente
                                            "
                                            :tooltipLabel="
                                                isNull(pdadetalhe['longitude'].label)
                                                    ? 'informacao-cliente-longitude'
                                                    : null
                                            "
                                            tooltipSize="is-small"
                                            tooltipPosition="is-top"
                                            :maxlength="50"
                                            validchars="0123456789-."
                                            :disabled="clienteExistente"
                                        />
                                    </div>
                                    <div>
                                        <div class="column is-3" v-if="this.windowWidth > 920">
                                            <button
                                                class="save-btn botao-localizacao"
                                                type="button"
                                                @click="openLocationEditor"
                                                :disabled="clienteExistente"
                                            >
                                                {{ $t('pesquisar-localizacao') }}
                                            </button>
                                        </div>
                                        <div
                                            v-else
                                            class="control padding-label padding-label-custom"
                                        >
                                            <b-button
                                                @click="openLocationEditor"
                                                icon-right="map-marker"
                                                type="is-primary"
                                                :disabled="clienteExistente"
                                                v-tippy
                                                :title="$t('pesquisar-localizacao')"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <VerifiedConfigExtra
                            v-if="showConfigExtra"
                            tabela="cliente"
                            :extra="extra"
                            :isUpdate="true"
                            :checkValidations="checkValidations"
                            @validating="checkValidations = $event"
                            @onChange="changeValConfigExtra($event)"
                            @hasExtra="hasExtra.endereco = $event"
                            aba="endereco"
                            :cantEdit="clienteExistente"
                            :isRequired="!clienteExistente"
                        />
                    </div>
                    <div
                        ref="tab-contato"
                        class="tab-contato page-container form-columns-fit mt-4 mb-4"
                        v-if="!conflito.has"
                        v-show="hasFields.contato"
                    >
                        <div class="columns is-flex-wrap">
                            <div
                                class="column is-4"
                                v-if="pdadetalhe['telefone'] && !pdadetalhe['telefone'].oculta"
                            >
                                <v-input-tel
                                    :id="generateId(170)"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    ref="telefone"
                                    v-model="cliente.telefone"
                                    :title="
                                        !isNull(pdadetalhe['telefone'].label)
                                            ? pdadetalhe['telefone'].label
                                            : 'telefone'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['telefone'].label)"
                                    :msg="pdadetalhe['telefone'].msg"
                                    :invalid="pdadetalhe['telefone'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('telefone')"
                                    :required="
                                        pdadetalhe['telefone'].obrigainclusao && !clienteExistente
                                    "
                                    :edit="inputTelefoneEdit"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['telefone'].label)
                                            ? 'informacao-cliente-telefone'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :maxlength="20"
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div
                                class="column is-4"
                                v-if="pdadetalhe['celular'] && !pdadetalhe['celular'].oculta"
                            >
                                <v-input-tel
                                    :id="generateId(180)"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    ref="celular"
                                    v-model="cliente.celular"
                                    :title="
                                        !isNull(pdadetalhe['celular'].label)
                                            ? pdadetalhe['celular'].label
                                            : 'celular'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['celular'].label)"
                                    :msg="pdadetalhe['celular'].msg"
                                    :invalid="pdadetalhe['celular'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('celular')"
                                    :required="
                                        pdadetalhe['celular'].obrigainclusao && !clienteExistente
                                    "
                                    :edit="inputCelularEdit"
                                    :icon="clienteExistente ? '' : 'content-copy'"
                                    @input-action="copyToWhatsApp"
                                    :iconTooltip="'copiar-tel-para-o-campo-wpp'"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['celular'].label)
                                            ? 'informacao-cliente-celular'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :maxlength="20"
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div
                                class="column is-4"
                                v-if="pdadetalhe['fax'] && !pdadetalhe['fax'].oculta"
                            >
                                <v-input-tel
                                    v-if="!copyToWhatsAppActive"
                                    :id="generateId(190)"
                                    ref="fax"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.fax"
                                    :title="
                                        !isNull(pdadetalhe['fax'].label)
                                            ? pdadetalhe['fax'].label
                                            : 'fax-do-cliente'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['fax'].label)"
                                    :edit="inputFaxEdit"
                                    :msg="pdadetalhe['fax'].msg"
                                    :invalid="pdadetalhe['fax'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('fax')"
                                    :required="
                                        pdadetalhe['fax'].obrigainclusao && !clienteExistente
                                    "
                                    :tooltipLabel="
                                        isNull(pdadetalhe['fax'].label)
                                            ? 'informacao-cliente-fax'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :maxlength="20"
                                    :disabled="clienteExistente"
                                />
                                <v-input v-else disabled title="fax-do-cliente" />
                            </div>
                            <div
                                class="column is-6"
                                v-if="pdadetalhe['email'] && !pdadetalhe['email'].oculta"
                            >
                                <v-input
                                    :id="generateId(200)"
                                    ref="email"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.email"
                                    placeholder="placeholder-preencha"
                                    :title="
                                        !isNull(pdadetalhe['email'].label)
                                            ? pdadetalhe['email'].label
                                            : 'email'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['email'].label)"
                                    :msg="pdadetalhe['email'].msg"
                                    :invalid="pdadetalhe['email'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('email')"
                                    :required="
                                        pdadetalhe['email'].obrigainclusao && !clienteExistente
                                    "
                                    :icon="clienteExistente ? '' : 'content-copy'"
                                    :iconTooltip="'copiar-email-para-o-campo-email-NFE'"
                                    @input-action="copyEmail"
                                    type="email"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['email'].label)
                                            ? 'informacao-cliente-email'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :validchars="pdadetalhe['email'].validchars"
                                    :maxlength="
                                        pdadetalhe['email'].maxlength > 0
                                            ? pdadetalhe['email'].maxlength
                                            : 50
                                    "
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div
                                class="column is-6"
                                v-if="pdadetalhe['emailnfe'] && !pdadetalhe['emailnfe'].oculta"
                            >
                                <v-input
                                    :id="generateId(210)"
                                    ref="emailnfe"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    v-model="cliente.emailNfe"
                                    placeholder="placeholder-preencha"
                                    :title="
                                        !isNull(pdadetalhe['emailnfe'].label)
                                            ? pdadetalhe['emailnfe'].label
                                            : 'email-nfe'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['emailnfe'].label)"
                                    :msg="pdadetalhe['emailnfe'].msg"
                                    :invalid="pdadetalhe['emailnfe'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('emailnfe')"
                                    :required="
                                        pdadetalhe['emailnfe'].obrigainclusao && !clienteExistente
                                    "
                                    type="email"
                                    :tooltipLabel="
                                        isNull(pdadetalhe['emailnfe'].label)
                                            ? 'informacao-cliente-emailnfe'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :validchars="pdadetalhe['emailnfe'].validchars"
                                    :maxlength="
                                        pdadetalhe['emailnfe'].maxlength > 0
                                            ? pdadetalhe['emailnfe'].maxlength
                                            : 50
                                    "
                                    :disabled="clienteExistente"
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        ref="tab-obs"
                        class="tab-obs page-container sem-margem-bottom mt-4 mb-4"
                        v-if="!conflito.has"
                        v-show="hasFields.obs || hasExtra.obs"
                    >
                        <div class="columns is-flex-wrap">
                            <div
                                class="column is-6"
                                v-if="
                                    pdadetalhe['obscadastral'] && !pdadetalhe['obscadastral'].oculta
                                "
                            >
                                <v-textarea
                                    ref="obscadastral"
                                    :id="generateId(220)"
                                    v-model="cliente.obsCadastral"
                                    :title="
                                        !isNull(pdadetalhe['obscadastral'].label)
                                            ? pdadetalhe['obscadastral'].label
                                            : 'obscadastral'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['obscadastral'].label)"
                                    :msg="pdadetalhe['obscadastral'].msg"
                                    placeholder="placeholder-preencha"
                                    :rows="5"
                                    :maxRows="5"
                                    :disableTransform="true"
                                    :invalid="pdadetalhe['obscadastral'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('obscadastral')"
                                    :required="
                                        pdadetalhe['obscadastral'].obrigainclusao &&
                                        !clienteExistente
                                    "
                                    :tooltipLabel="
                                        isNull(pdadetalhe['obscadastral'].label)
                                            ? 'informacao-cliente-obscadastral'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :validchars="pdadetalhe['obscadastral'].validchars"
                                    :maxlength="
                                        pdadetalhe['obscadastral'].maxlength > 0
                                            ? pdadetalhe['obscadastral'].maxlength
                                            : 1000
                                    "
                                    :disabled="clienteExistente"
                                />
                            </div>
                            <div
                                class="column is-6"
                                v-if="
                                    pdadetalhe['obsfinanceira'] &&
                                    !pdadetalhe['obsfinanceira'].oculta
                                "
                            >
                                <v-textarea
                                    ref="obsfinanceira"
                                    :id="generateId(220)"
                                    v-model="cliente.obsFinanceira"
                                    :title="
                                        !isNull(pdadetalhe['obsfinanceira'].label)
                                            ? pdadetalhe['obsfinanceira'].label
                                            : 'obsfinanceira'
                                    "
                                    :disableMLtitle="!isNull(pdadetalhe['obsfinanceira'].label)"
                                    :msg="pdadetalhe['obsfinanceira'].msg"
                                    placeholder="placeholder-preencha"
                                    :rows="5"
                                    :maxRows="5"
                                    :disableTransform="true"
                                    :invalid="pdadetalhe['obsfinanceira'].invalid"
                                    @onBlurFunction="validadeByPdaDetalhe('obsfinanceira')"
                                    :required="
                                        pdadetalhe['obsfinanceira'].obrigainclusao &&
                                        !clienteExistente
                                    "
                                    :tooltipLabel="
                                        isNull(pdadetalhe['obsfinanceira'].label)
                                            ? 'informacao-cliente-obsfinanceira'
                                            : null
                                    "
                                    tooltipSize="is-small"
                                    tooltipPosition="is-top"
                                    :validchars="pdadetalhe['obsfinanceira'].validchars"
                                    :maxlength="
                                        pdadetalhe['obsfinanceira'].maxlength > 0
                                            ? pdadetalhe['obsfinanceira'].maxlength
                                            : 1000
                                    "
                                    :disabled="clienteExistente"
                                />
                            </div>
                        </div>
                        <VerifiedConfigExtra
                            ref="tab-extra"
                            v-if="showConfigExtra"
                            tabela="cliente"
                            :extra="extra"
                            :isUpdate="true"
                            :checkValidations="checkValidations"
                            @validating="checkValidations = $event"
                            @onChange="changeValConfigExtra($event)"
                            @hasExtra="hasExtra.obs = $event"
                            aba="obs"
                            :cantEdit="clienteExistente"
                            :isRequired="!clienteExistente"
                        />
                    </div>

                    <MapasGoogleMapsModal
                        v-if="startedMaps"
                        :center="center"
                        :isUpdating="isSaving"
                        :locationEditorOpen="locationEditorOpen"
                        :update="true"
                        label="selecionar"
                        @updateLocation="updateLocation"
                        @onCancelLocationEditor="onCancelLocationEditor"
                        :startSearchWith="startSearchWith"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LeadsService from '@/services/vendas/LeadsService';
import ClienteService from '@/services/vendas/cliente/ClienteService';
import CidadeService from '@/services/CidadeService';
import SituacaoService from '@/services/SituacaoService';
import RegiaoService from '@/services/RegiaoService';
import AtividadeService from '@/services/AtividadeService';
import RamoService from '@/services/RamoService';
import TransportadoraService from '@/services/vendas/TransportadoraService';
import GrupoEconomicoService from '@/services/agro/GrupoEconomicoService';
import HideInfo from '@/components/shared/HideInfo';
import Message from '@/models/Message';
import { TheMask } from 'vue-the-mask';
import * as InscricaoEstadual from '@/functions/IEValidation';
import { mapState } from 'vuex';
import MapasGoogleMapsModal from '@/components/shared/maps/MapasGoogleMapsModal';
import VerifiedConfigExtra from '@/components/shared/form/VerifiedConfigExtra';
import CidadeModal from '@/components/vendas/cliente/modal/CidadeModal';
import RegiaoCadastroModal from '@/components/vendas/cliente/modal/RegiaoCadastroModal.vue';
import SituacaoCadastroModal from '@/components/vendas/cliente/modal/SituacaoCadastroModal.vue';
import GrupoEconomicoCadastroModal from '@/components/agro/grupoeconomico/modal/GrupoEconomicoCadastroModal.vue';
import allCountries from '@/assets/all-countries';
import { isNull } from '@/functions/Util';

export default {
    beforeRouteLeave(to, from, next) {
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        TheMask,
        HideInfo,
        MapasGoogleMapsModal,
        CidadeModal,
        VerifiedConfigExtra,
        RegiaoCadastroModal,
        SituacaoCadastroModal,
        GrupoEconomicoCadastroModal,
    },
    props: {
        telaCliente: {
            type: String,
            default: '',
        },
        id: {
            type: [Number, String],
            default: 0,
        },
        leadName: {
            type: String,
            default: '',
        },
        leadStatus: {
            type: [Number, String],
            default: '',
        },
    },
    data() {
        return {
            windowWidth: window.innerWidth,
            leadsService: new LeadsService(this.$http, this.$router),
            clienteService: new ClienteService(this.$http, this.$router),
            cidadeService: new CidadeService(this.$http, this.$router),
            situacaoService: new SituacaoService(this.$http, this.$router),
            regiaoService: new RegiaoService(this.$http, this.$router),
            atividadeService: new AtividadeService(this.$http, this.$router),
            ramoService: new RamoService(this.$http, this.$router),
            transportadoraService: new TransportadoraService(this.$http, this.$router),
            grupoEconomicoService: new GrupoEconomicoService(this.$http, this.$router),

            countries: allCountries,

            //variáveis para pegar valor das props, permitindo mudança após leitura do back caso não venha pelas props
            leadNameInner: '',
            leadStatusInner: 0,
            msgs: [],

            isLoading: false,
            isSaving: false,
            isSavingRejeitar: false,
            isSavingAprovar: false,
            isChanged: false,
            permissao: false,

            isSearchingCEP: false,

            inputFaxEdit: false,
            inputCelularEdit: false,
            inputTelefoneEdit: false,

            cliente: {
                idClienteProspeccao: null,
                idClienteErp: null,
                idCidade: null,
                idEmpresa: null,
                idAtividade: null,
                idRamo: null,
                idRegiao: null,
                idSituacao: null,
                idMatriz: null,
                idTransportadora: null,
                idGrupoEconomico: null,
                idUsuario: 0,
                coefTabPreco: 1,
                nome: null,
                rsocial: null,
                endereco: null,
                numero: null,
                bairro: null,
                cep: null,
                ierg: null,
                cnpjcpf: null, // not null
                telefone: null,
                fax: null,
                celular: null,
                email: null,
                emailNfe: null,
                dataNascimento: null,
                obsCadastral: null,
                obsFinanceira: null,
                extra1: null,
                extra2: null,
                extra3: null,
                latitude: null,
                longitude: null,
                complemento: null,
                estrangeiro: 0,
                tipoCliente: null,
                contribuinte: null,
                tipoConsumidor: 0,
                origemCliente: null,
                replicapda: 0,

                idCadastrante: null,
                cadastranteNome: null,
                cadastranteCpf: null,
                cadastranteEmail: null,
                cadastranteWhatsapp: null,
            },
            dataNascimento: null,
            // campos com código campo em pdadetalhe direfente da chave da coluna
            tests: [
                'regiao',
                'atividade',
                'ramo',
                'matriz',
                'situacao',
                'cidade',
                'transportadora',
                'grupoeconomico',
            ],
            // campos que utilizam camelCase no objeto de cliente, para conversão conforme modulopda
            camelCase: [
                'obsFinanceira',
                'obsCadastral',
                'emailNfe',
                'dataNascimento',
                'grupoEconomico',
            ],

            // campos dligados a tabela configextra
            extra: {
                extra1: {
                    value: null,
                    obgInc: false,
                    obgAlt: false,
                    validated: true,
                    msg: null,
                },
                extra2: {
                    value: null,
                    obgInc: false,
                    obgAlt: false,
                    validated: true,
                    msg: null,
                },
                extra3: {
                    value: null,
                    obgInc: false,
                    obgAlt: false,
                    validated: true,
                    msg: null,
                },
            },
            // validação para exibição de tabs
            hasFields: {
                geral: true,
                endereco: true,
                contato: true,
                obs: true,
            },
            hasExtra: {
                geral: true,
                endereco: true,
                obs: true,
            },

            copyToWhatsAppActive: false,
            center: { lat: 0, lng: 0 },
            locationEditorOpen: false,
            buscaCep: null,
            startSearchWith: '',
            startedMaps: false,
            pdadetalhe: {},
            pdadetalheHasData: false,

            cidadeSelect: [],
            cidadeSelected: null,
            regiaoSelect: [],
            regiaoSelected: null,
            situacaoSelect: [],
            situacaoSelected: null,
            atividadeSelect: [],
            atividadeSelected: null,
            ramoSelect: [],
            ramoSelected: null,
            matrizSelect: [],
            matrizSelected: null,
            transportadoraSelect: [],
            transportadoraSelected: null,
            grupoEconomicoSelect: [],
            grupoEconomicoSelected: null,
            vendedorSelect: [],
            vendedorSelected: null,
            hasGrupoEconomicoPermission: true,

            pessoaSelect: [
                { label: 'pessoa-juridica', id: 1 },
                { label: 'pessoa-fisica', id: 0 },
            ],
            pessoaSelected: { label: 'pessoa-juridica', id: 1 },
            estrangeiroSelect: [
                { label: 'nao', id: 0 },
                { label: 'sim', id: 1 },
            ],
            estrangeiroSelected: { label: 'nao', id: 0 },
            contribuinteSelect: [
                { label: 'contribuinte-icms', id: 'C' },
                { label: 'contribuinte-isento', id: 'I' },
                { label: 'contribuinte-nao', id: 'N' },
            ],
            contribuinteSelected: { label: 'contribuinte-icms', id: 'C' },
            tipoConsumidorSelect: [
                { label: 'consumidor-final', id: 1 },
                { label: 'consumidor-normal', id: 0 },
            ],
            tipoConsumidorSelected: { label: 'consumidor-normal', id: 0 },

            // esconde config extra até ter dados no edit
            showConfigExtra: false,
            checkValidations: false,
            // para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: true,
            // flag para aguardar retorno de dados do componente VerifiedConfigExtra sem alterar a variável isChanged
            extrasValidated: true,
            // regra para exibissão de conflito entre as configs do modulopdadetalhe e o banco de dados
            conflito: {
                has: false,
                config: false,
                oculto: false,
            },
            conflitoFieldConfig: '',
            conflitoFieldOculto: '',
            //visto que 'vendedor' não tem modulopda correspondente, tal objeto é utilizado para validação do campo
            vendedor: {
                msg: null,
                invalid: false,
            },

            // Modal de cadastro de região
            showModalCadastroSituacao: false,
            showModalCadastroRegiao: false,
            showModalCadastroGrupoEconomico: false,

            //lista de requisições que armazena chaves das requisições realizadas. Ao efetuar a requisição, a chave é inserida. Ao finalizar, ela é removida
            //utilizada para sincronizar alterações na tela com o carregamento dos dados de todos os campos de seleção
            requestQueue: [],

            //verifica se cliente ja esta cadastrado
            clienteExistente: false,
            idClienteExistente: 0,
            codigoClienteExistente: '',
            cnpjcpfClienteExistente: '',
            nomeClienteExistente: '',
        };
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    computed: {
        ...mapState(['hide']),
    },
    watch: {
        cliente: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit && !this.isSaving) {
                    this.isChanged = true;
                }
            },
        },
        contribuinteSelected: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.changeContribuinte();
                }
            },
        },
        requestQueue() {
            if (this.requestQueue.length == 0) {
                //timeout pequeno utilizado para que a mudança em todos os dados carregados seja finalizada
                setTimeout(() => {
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                }, 10);
            }
        },
    },
    created() {
        this.leadNameInner = this.leadName;
        this.leadStatusInner = this.leadStatus;
        this.permissao = this.hasPermissionAccess('vendas', 'clientes', 'leads');
        if (!this.permissao.create || !this.permissao.update || !this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'leads' },
            });
        } else {
            this.showConfigExtra = false;

            this.getModulo('CLIENTE').detalhe.forEach((d) => {
                d.invalid = false;
                d.msg = 'msg-campo-obrigatorio';
                this.$set(this.pdadetalhe, d.campo.toLowerCase(), d);
                // Caso tenha dados em pdadetalhe
                this.pdadetalheHasData = true;
            });

            let grupoeconomicoPermissoes = this.hasPermissionAccess(
                'agro',
                'agro-cadastros',
                'cli-grupoeconomico'
            );
            this.hasGrupoEconomicoPermission = grupoeconomicoPermissoes.create;

            /* validação por campos não nulos na tabela cliente;
            Caso um destes campos não estejam configurados corretamente, 
            avisar para ajustar o modulopdadetalhe no mobileManager */
            let fields = ['nome', 'cnpjcpf'];
            fields.forEach((field) => {
                this.checkInvalidConfig(field);
            });

            this.carregarDados();
        }
    },
    mounted() {
        this.hasFields.geral =
            this.$refs['tab-geral'] != undefined
                ? this.$refs['tab-geral'].firstChild.children.length > 0
                : false;
        this.hasFields.endereco =
            this.$refs['tab-endereco'] != undefined
                ? this.$refs['tab-endereco'].firstChild.children.length > 0
                : false;
        this.hasFields.contato =
            this.$refs['tab-contato'] != undefined
                ? this.$refs['tab-contato'].firstChild.children.length > 0
                : false;
        this.hasFields.obs =
            this.$refs['tab-obs'] != undefined
                ? this.$refs['tab-obs'].firstChild.children.length > 0
                : false;

        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });
    },
    methods: {
        onResize() {
            this.windowWidth = window.innerWidth;
        },
        generateId(numberId) {
            return this.$route.name + '-geral-' + numberId;
        },
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', { infoIsHidden: !this.hide.infoIsHidden });
        },
        redirectToListPage() {
            this.$router.push({ name: 'ven-leads-list' });
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        checkInvalidConfig(field) {
            if (!this.pdadetalhe[field]) {
                this.conflitoFieldConfig += ' *' + this.$t(field);
                this.conflito.has = true;
                this.conflito.config = true;
            }
            if (this.pdadetalhe[field] && this.pdadetalhe[field].oculta) {
                this.conflitoFieldOculto += ' *' + this.$t(field);
                this.conflito.has = true;
                this.conflito.oculto = true;
            }
        },
        sendIsChanged(label = null) {
            if (!this.isLoadingEdit) {
                this.isChanged = true;
            }
            // Já aproveita e faz a validação do pdadetalhe
            if (label != null) this.validadeByPdaDetalhe(label);
        },
        changeValConfigExtra(tempExtra) {
            if (!this.isLoadingEdit && this.extrasValidated) {
                this.isChanged = true;
            }
            Object.entries(tempExtra).forEach(([key, value]) => {
                this.extra[key].validated = value.validated;
                this.extra[key].value = value.value;
            });
        },
        changeContribuinte() {
            if (this.pessoaSelected.id == 1 && this.estrangeiroSelected.id == 0) {
                if (this.contribuinteSelected.id == 'I') {
                    // caso passe para isento seta o valor isento
                    this.cliente.ierg = 'ISENTO';
                } else if (this.cliente.ierg == 'ISENTO') {
                    // caso venha de isento seta o valor para null, caso contrario mantém a IE
                    this.cliente.ierg = null;
                }
                this.validadeByPdaDetalhe('ierg');
            }
        },
        validadeByPdaDetalhe(field) {
            //manda valores dos objetos internos para o objeto de cliete
            this.sendValuesToCliente(field);

            if (field == 'vendedor') {
                return this.validaVendedor();
            } else {
                // limpa a validação para iniciar os testes
                this.pdadetalhe[field].invalid = false;
            }

            if (this.customValidations(field)) {
                // valida campos com validações adicionais
                return this.pdadetalhe[field].invalid;
            } else if (this.obrigaInclusao(field)) {
                // valida por obrigainclusao
                return this.pdadetalhe[field].invalid;
            }

            return this.pdadetalhe[field].invalid;
        },
        sendValuesToCliente(field) {
            if (field == 'datanascimento') {
                this.cliente.dataNascimento =
                    this.dataNascimento != null && this.$moment(this.dataNascimento).isValid()
                        ? this.$moment(this.dataNascimento).format('YYYY-MM-DD')
                        : null;
            } else if (field == 'regiao') {
                this.cliente.idRegiao = this.regiaoSelected != null ? this.regiaoSelected.id : 0;
            } else if (field == 'atividade') {
                this.cliente.idAtividade =
                    this.atividadeSelected != null ? this.atividadeSelected.id : 0;
            } else if (field == 'ramo') {
                this.cliente.idRamo = this.ramoSelected != null ? this.ramoSelected.id : 0;
            } else if (field == 'situacao') {
                this.cliente.idSituacao =
                    this.situacaoSelected != null ? this.situacaoSelected.id : 0;
            } else if (field == 'matriz') {
                this.cliente.idMatriz = this.matrizSelected != null ? this.matrizSelected.id : 0;
            } else if (field == 'transportadora') {
                this.cliente.idTransportadora =
                    this.transportadoraSelected != null ? this.transportadoraSelected.id : 0;
            } else if (field == 'grupoeconomico') {
                this.cliente.idGrupoEconomico =
                    this.grupoEconomicoSelected != null ? this.grupoEconomicoSelected.id : 0;
            } else if (field == 'tipoconsumidor') {
                this.cliente.tipoConsumidor =
                    this.tipoConsumidorSelected != null ? this.tipoConsumidorSelected.id : 0;
            } else if (field == 'cidade') {
                this.cliente.idCidade = this.cidadeSelected != null ? this.cidadeSelected.id : 0;
            } else if (field == 'vendedor') {
                this.cliente.idUsuario =
                    this.vendedorSelected != null ? this.vendedorSelected.id : 0;
            }
        },
        customValidations(field) {
            if (!this.isNull(this.cliente[field])) {
                //só valida campos não nulos
                if (this.estrangeiroSelected.id == 0) {
                    //validações exclusivas de clientes brasileiros
                    if (field == 'cep' && !this.validateCEP(this.cliente.cep)) {
                        this.setPDADetalheInvalid(field);
                    } else if (field == 'celular' && !this.validatePhone(this.cliente.celular)) {
                        this.setPDADetalheInvalid(field);
                    } else if (
                        field == 'fax' &&
                        !this.validatePhone(this.cliente.fax) &&
                        !this.validatePhone(this.cliente.fax)
                    ) {
                        this.setPDADetalheInvalid(field);
                    } else if (field == 'telefone' && !this.validatePhone(this.cliente.telefone)) {
                        this.setPDADetalheInvalid(field);
                    } else if (field == 'ierg') {
                        if (this.pessoaSelected.id == 0 && !this.validateRG(this.cliente.ierg)) {
                            this.setPDADetalheInvalid(field);
                        } else if (
                            this.pessoaSelected.id == 1 &&
                            this.contribuinteSelected.id != 'I' &&
                            !this.validateIE()
                        ) {
                            this.setPDADetalheInvalid(field);
                        }
                    }
                } else if (field == 'latitude' && !this.validateLatitude(this.cliente.latitude)) {
                    this.setPDADetalheInvalid(field);
                } else if (
                    field == 'longitude' &&
                    !this.validateLongitude(this.cliente.longitude)
                ) {
                    this.setPDADetalheInvalid(field);
                } else if (field == 'email' && !this.validateEmail(this.cliente.email)) {
                    this.setPDADetalheInvalid(field);
                } else if (field == 'emailnfe' && !this.validateEmail(this.cliente.emailNfe)) {
                    this.setPDADetalheInvalid(field);
                }
            }
            return this.pdadetalhe[field].invalid;
        },
        setPDADetalheInvalid(field) {
            this.pdadetalhe[field].invalid = true;
            this.pdadetalhe[field].msg = 'msg-campo-invalido';
        },
        validateIE() {
            if (this.cidadeSelected == null) {
                /*
                    @85324 - É necessário que o estado (UF) seja reconhecido a partir da cidade para verificar a validade da inscrição estadual 
                    Não foi escolhido verificar o estado a partir da máscara, pois a máscara não é padronizada para diferentes estados
                */
                this.msgs.push(new Message('alert', 'msg-problema-preencher-cidade-cliente', true));
            } else {
                let temp = InscricaoEstadual.validateIE(
                    this.cliente.ierg,
                    this.cidadeSelected.estado
                );
                return temp;
            }
        },
        obrigaInclusao(field) {
            if (
                field == 'cnpjcpf' ||
                field == 'estrangeiro' ||
                (field == 'ierg' && this.estrangeiroSelected.id == 1)
            ) {
                //'cnpjcpf' e 'estrangeiro' vêm do banco de dados e não são alteráveis
                this.pdadetalhe[field].invalid = false;
                return this.pdadetalhe[field].invalid;
            }

            // verifica se campo é utilizado no objeto cliente com camelCase
            let camelCaseIndex = this.camelCase.findIndex((f) => f.toLowerCase() == field);
            let fieldCliente = camelCaseIndex >= 0 ? this.camelCase[camelCaseIndex] : field;

            // faz ajustes para campos com código campo em pdadetalhe direfente da chave da coluna
            if (this.tests.includes(field)) {
                // concatena 'id' com o campo seguindo padrão camelCase
                fieldCliente = 'id' + fieldCliente.charAt(0).toUpperCase() + fieldCliente.slice(1);
            }

            if (fieldCliente == 'cepestrangeiro') {
                fieldCliente = 'cep';
            }

            if (
                // field == "campo obrigatório sobrepondo regra da pdadetalhe"
                (this.pdadetalhe[field].obrigainclusao || field == 'situacao' || field == 'nome') &&
                (this.isNull(this.cliente[fieldCliente]) || this.cliente[fieldCliente] == 0)
            ) {
                this.pdadetalhe[field].invalid = true;
                this.pdadetalhe[field].msg = 'msg-campo-obrigatorio';
            }
            return this.pdadetalhe[field].invalid;
        },
        validaVendedor() {
            this.vendedor.invalid = false;

            if (this.cliente.idUsuario == 0) {
                this.vendedor.invalid = true;
                this.vendedor.msg = 'msg-campo-obrigatorio';
            }
            return this.vendedor.invalid;
        },
        confirmarRejeicao() {
            this.isSaving = true;
            this.isSavingRejeitar = true;

            let msg;
            if (this.isNull(this.cliente.nome)) {
                msg = this.$t('msg-confirmacao-rejeicao-lead');
            } else if (this.clienteExistente) {
                msg = this.$t('msg-confirmacao-rejeicao-vinculo-n', 
                    { 
                        cadastrante: this.cliente.cadastranteNome, 
                        cliente: this.cliente.nome
                    }
                );
            } else {
                msg = this.$t('msg-confirmacao-rejeicao-lead-n', { n: this.cliente.nome });
            }

            this.$root.confirm({
                message: msg,
                onConfirm: (_) => this.rejeitar(),
                onCancel: (_) => this.cancelSaving(),
            });
        },
        cancelSaving() {
            //timeout pequeno utilizado para que a mudança em todos os dados carregados seja finalizada
            setTimeout(() => {
                this.isSaving = false;
                this.isSavingRejeitar = false;
                this.isSavingAprovar = false;
            }, 10);
        },
        rejeitar() {
            this.isLoading = true;
            this.leadsService
                .reject({
                    idClienteProspeccao: this.cliente.idClienteProspeccao,
                    cnpjcpf: this.cliente.cnpjcpf.replaceAll(/[^0-9]/g, ''),
                })
                .then((value) => {
                    if (value.message == null) {
                        let msg = 'msg-sucesso-rejeitar-cadastro';
                        this.$root.showMessage('success', msg, true);
                        this.isChanged = false;
                        this.redirectToListPage();
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(new Message('alert', value.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    if (e.body.status == 409) {
                        this.msgs.push(new Message('alert', e.body.message, true));
                    } else {
                        console.error('Erro ao salvar: ' + e);
                        this.msgs.push(new Message('error', 'msg-erro-salvar', true));
                    }
                })
                .finally(() => {
                    this.cancelSaving();
                    this.isLoading = false;
                });
        },
        validateData() {
            this.extrasValidated = false;
            this.isSaving = true;
            this.isSavingAprovar = true;
            let invalid = false;
            let invalidFields = '';

            // valida todos os campos caso seja cadastro de novo cliente
            if (!this.clienteExistente) {
                // inicia validação dos campos extras
                this.checkValidations = true;

                Object.entries(this.extra).forEach(([key, value]) => {
                    if (!value.validated) {
                        invalid = true;
                        invalidFields += ' - ' + key;
                    }
                });

                this.cliente.extra1 = this.extra.extra1.value;
                this.cliente.extra2 = this.extra.extra2.value;
                this.cliente.extra3 = this.extra.extra3.value;

                this.cliente.contribuinte =
                    this.pessoaSelected.id == 1 && this.estrangeiroSelected.id == 0
                        ? this.contribuinteSelected.id
                        : null;
                this.cliente.tipoConsumidor =
                    this.tipoConsumidorSelected != null ? this.tipoConsumidorSelected.id : 0;

                // inicia validação dos campos do pdadetalhe
                Object.entries(this.$refs).forEach(([key, value]) => {
                    if (this.pdadetalhe[key] || key == 'vendedor') {
                        this.validadeByPdaDetalhe(key);
                    }
                });

                Object.entries(this.$refs).forEach(([key, value]) => {
                    if (this.pdadetalhe[key]) {
                        if (this.pdadetalhe[key].invalid) {
                            invalid = true;
                            invalidFields += ' - ' + key;
                        }
                    } else if (key == 'vendedor') {
                        if (this.vendedor.invalid) {
                            invalid = true;
                            invalidFields += ' - ' + key;
                        }
                    }
                });
            } else {
                // valida apenas vendedor caso seja vínculo com um cliente já cadastrado
                this.validadeByPdaDetalhe('vendedor');
                if (this.vendedor.invalid) {
                    invalid = true;
                    invalidFields += ' - vendedor';
                }
            }

            if (invalid) {
                console.warn('Campos inválidos', invalidFields);
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    if (value != undefined) value.focusedOut = true;
                });

                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
                this.cancelSaving();

                setTimeout(() => {
                    //setTimeout de 550 para esperar validação dos campos extras (timeout interno do componente é de 500ms)
                    this.extrasValidated = true;
                }, 550);
            } else {
                // passou por todas as validações
                if (this.clienteExistente) {
                    this.confirmVinculo();
                } else {
                    this.confirmarAprovacao();
                }
            }
        },
        confirmVinculo() {
            let msg = this.$t('msg-confirmacao-aprovacao-vinculo-n', 
                { 
                    cadastrante: this.cliente.cadastranteNome,
                    cliente: this.cliente.nome,
                }
            );

            this.$root.confirm({
                message: msg,
                onConfirm: (_) => this.vincular(),
                onCancel: (_) => this.cancelSaving(),
            });
        },
        vincular() {
            this.isLoading = true;
            this.leadsService
                .vincular({
                    idClienteProspeccao: this.cliente.idClienteProspeccao,
                    idCliente: this.idClienteExistente,
                    cnpjcpf: this.cliente.cnpjcpf.replaceAll(/[^0-9]/g, ''),
                    idUsuario: this.vendedorSelected.id,
                    idClienteErp: this.cliente.idClienteErp,
                })
                .then((value) => {
                    this.isChanged = false;
                    this.$root.showMessage('success', 'msg-sucesso-vinculo', true);
                    this.redirectToListPage();
                })
                .catch((e) => {
                    console.error('Erro ao salvar: ' + e);
                    this.msgs.push(new Message('error', 'msg-erro-salvar', true));
                })
                .finally(() => {
                    this.cancelSaving();
                    this.isLoading = false;
                });
        },
        confirmarAprovacao() {
            let msg = this.$t('msg-confirmacao-aprovacao-lead-n', { n: this.cliente.nome });

            this.$root.confirm({
                message: msg,
                onConfirm: (_) => this.save(),
                onCancel: (_) => this.cancelSaving(),
            });
        },
        save() {
            this.isSaving = true;
            this.isLoading = true;

            let clienteTemp = Object.assign({}, this.cliente);
            clienteTemp = this.mapTosave(
                clienteTemp,
                'cnpjcpf',
                'extra1',
                'extra2',
                'extra3',
                'telefone',
                'celular',
                'fax',
                'idEmpresa',
                'email',
                'emailNfe',
                'obsCadastral',
                'obsFinanceira'
            );

            clienteTemp.cnpjcpf = clienteTemp.cnpjcpf.replace(/[^0-9]/g, '');
            if (clienteTemp.estrangeiro == 0 && clienteTemp.cep != null) {
                clienteTemp.cep = clienteTemp.cep.replace(/[^0-9]/g, '');
            }
            this.leadsService
                .save(clienteTemp)
                .then((value) => {
                    if (value.message == null) {
                        this.isChanged = false;
                        let msg =
                            value.content == 0
                                ? 'msg-sucesso-aguardando-erp'
                                : 'msg-sucesso-aprovar-cadastro';
                        this.$root.showMessage('success', msg, true);
                        this.redirectToListPage();
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(new Message('alert', value.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    if (e.body.status == 409) {
                        this.msgs.push(new Message('alert', e.body.message, true));
                    } else {
                        console.error('Erro ao salvar: ' + e);
                        this.msgs.push(new Message('error', 'msg-erro-salvar', true));
                    }
                })
                .finally(() => {
                    this.cancelSaving();
                    this.isLoading = false;
                });
        },
        removeFromRequestQueue(item) {
            let index = this.requestQueue.indexOf(item);
            if (index != -1) {
                this.requestQueue.splice(index, 1);
            }
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.requestQueue.push('cliente');
            this.leadsService
                .find(this.$route.params.id)
                .then((body) => {
                    this.checkClienteExistente(body.content.cnpjcpf.replaceAll(/[^0-9]/g, ''));

                    if (this.isNull(this.leadNameInner)) this.leadNameInner = body.content.nome;
                    if (this.isNull(this.leadStatusInner))
                        this.leadStatusInner = body.content.replicapda;

                    Object.entries(this.cliente).forEach(([key, value]) => {
                        if (body.content[key]) {
                            this.cliente[key] = this.isNull(body.content[key])
                                ? null
                                : body.content[key];
                        }
                    });

                    this.setCampos();
                })
                .catch((e) => {
                    console.error(e);
                    this.leadStatusInner = 3; //muda essa variável para bloquear edição dos campos caso não exista lead
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.removeFromRequestQueue('cliente');
                    this.isChanged = false;
                    this.runValidations(true);

                    this.startedMaps = true;
                    if (this.cliente.idClienteProspeccao != null) this.setExtras();
                });
        },
        checkClienteExistente(cnpj) {
            //recebe string de cnpj apenas com números
            this.requestQueue.push('cliente-existente');
            this.leadsService
                .checkCliente(cnpj)
                .then((body) => {
                    if (body.status == 200) {
                        this.idClienteExistente = body.content.id;
                        this.codigoClienteExistente = body.content.codigo;
                        this.cnpjcpfClienteExistente = body.content.cnpjcpf;

                        let nome = this.isNull(body.content.nome) ? '' : body.content.nome;
                        let rsocial = this.isNull(body.content.rsocial) ? '' : body.content.rsocial;
                        switch (body.content.tipo) {
                            case 'J':
                                this.nomeClienteExistente = this.isNull(rsocial) ? nome : rsocial;
                                break;
                            case 'F':
                                this.nomeClienteExistente = nome + ' ' + rsocial;
                                break;
                            default:
                                this.nomeClienteExistente = nome;
                        }

                        this.clienteExistente = true;
                    } else {
                        this.clienteExistente = false; //redefine variável para evitar que mensagem de erro seja exibida
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.removeFromRequestQueue('cliente-existente');
                    this.loadCamposSelecao();
                });
        },
        setCampos() {
            if (this.cliente.tipoCliente != null) {
                this.pessoaSelected = this.pessoaSelect.filter((f) => {
                    let tempPessoa = this.cliente.tipoCliente == 'F' ? 0 : 1;
                    return f.id == tempPessoa;
                })[0];
            }
            if (this.cliente.estrangeiro != null) {
                this.estrangeiroSelected = this.estrangeiroSelect.filter(
                    (f) => f.id == this.cliente.estrangeiro
                )[0];
            }
            if (this.cliente.contribuinte != null) {
                this.contribuinteSelected = this.contribuinteSelect.filter(
                    (f) => f.id == this.cliente.contribuinte
                )[0];
            }
            if (this.cliente.dataNascimento != null) {
                if (this.$moment(this.cliente.dataNascimento).isValid()) {
                    this.dataNascimento = this.$moment(this.cliente.dataNascimento).toDate();
                }
            }
            if (this.cliente.idCidade) {
                this.loadCidadeById(this.cliente.idCidade);
            }
            if (this.cliente.tipoConsumidor != null) {
                this.tipoConsumidorSelected = this.tipoConsumidorSelect.filter(
                    (f) => f.id == this.cliente.tipoConsumidor
                )[0];
            }

            this.cliente.celular = this.changeDDIPattern(this.cliente.celular);
            this.cliente.telefone = this.changeDDIPattern(this.cliente.telefone);
            this.cliente.fax = this.changeDDIPattern(this.cliente.fax);

            this.inputCelularEdit = !this.isNull(this.cliente.celular);
            this.inputTelefoneEdit = !this.isNull(this.cliente.telefone);
            this.inputFaxEdit = !this.isNull(this.cliente.fax);
        },
        loadCamposSelecao() {
            this.loadVendedores(); //campo obrigatório

            if (!this.clienteExistente) {
                // carrega infos dos selects caso os campos de seleção correspondentes sejam utilizados
                this.loadSituacao(); //campo obrigatório
                if (this.pdadetalhe['cidade'] && !this.pdadetalhe['cidade'].oculta) {
                    this.loadCidade();
                }
                if (this.pdadetalhe['regiao'] && !this.pdadetalhe['regiao'].oculta) {
                    this.loadRegiao();
                }
                if (this.pdadetalhe['atividade'] && !this.pdadetalhe['atividade'].oculta) {
                    this.loadAtividadeById();
                }
                if (this.pdadetalhe['ramo'] && !this.pdadetalhe['ramo'].oculta) {
                    this.loadRamo();
                }
                if (this.pdadetalhe['matriz'] && !this.pdadetalhe['matriz'].oculta) {
                    this.loadMatriz();
                }
                if (
                    this.pdadetalhe['transportadora'] &&
                    !this.pdadetalhe['transportadora'].oculta
                ) {
                    this.loadTransportadora();
                }
                if (
                    this.pdadetalhe['grupoeconomico'] &&
                    !this.pdadetalhe['grupoeconomico'].oculta
                ) {
                    this.loadGrupoEconomico();
                }
            }
        },
        changeDDIPattern(value) {
            /* 
                adapta padrão de DDI utilizado no B2B (apenas números com DDI separado por espaço: '1 3437895151') 
                para padrão do Web/FV (código do país em vez do número do DDI, separado por espaço: 'CA 3437895151')
            */
            if (!this.isNull(value)) {
                let ddiNumerico = value.split(' ')[0].trim();
                let ddi = this.countries.find((f) => f.dialCode == ddiNumerico).iso2;
                let numero = value.split(' ')[1].trim();
                if (ddi == undefined) ddi = ddiNumerico;

                return ddi + ' ' + numero;
            }
        },
        setExtras() {
            this.extra.extra1.value = !this.isNull(this.cliente.extra1)
                ? this.cliente.extra1
                : null;
            this.extra.extra2.value = !this.isNull(this.cliente.extra2)
                ? this.cliente.extra2
                : null;
            this.extra.extra3.value = !this.isNull(this.cliente.extra3)
                ? this.cliente.extra3
                : null;

            this.showConfigExtra = true;
        },
        runValidations(focusedOut = false) {
            if (focusedOut) {
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    if (value != undefined) value.focusedOut = true;
                });
            }
            /* Ao realizar o focusedOut no arquivo validation, as funções de validate não são chamadas, 
            tendo assim que faze-las manualmente, para poder apresentar os erros nos campos */
            let validationFields = [
                'cnpjcpf',
                'cep',
                'telefone',
                'celular',
                'fax',
                'latitude',
                'longitude',
                'email',
                'emailnfe',
            ];

            //valida quais dos campos acima efetivamente estão na moduloPDA
            validationFields.forEach((field) => {
                if (this.pdadetalhe[field]) this.customValidations(field);
            });
        },
        getInfoByCEP() {
            this.validadeByPdaDetalhe('cep');
            if (this.pdadetalhe['cep'].invalid) {
                this.msgs.push(new Message('error', 'msg-erro-pesquisa-cep-invalido', true));
            } else {
                let cep = this.cliente.cep;
                this.isSearchingCEP = true;
                let token = this.$moment().format('!%$MM(yyyy)DD*&');
                token = this.$CryptoJS.MD5(token).toString();

                this.clienteService
                    .getInfoByCEP(cep, token)
                    .then((data) => {
                        this.buscaCep = data.content;
                        this.cliente.bairro = data.content.bairro;
                        this.$refs.bairro.focusedOut = false;
                        this.cliente.endereco = data.content.logradouro;
                        this.$refs.endereco.focusedOut = false;
                        this.loadCidade(this.removeAcentos(data.content.cidade));
                    })
                    .catch((err) => {
                        console.error(err);
                        this.msgs.push(new Message('error', 'msg-erro-pesquisa-cep', true));
                    })
                    .finally((_) => {
                        this.isSearchingCEP = false;
                    });
            }
        },
        loadAtividades(searchQuery = '') {
            this.requestQueue.push('atividades');
            this.atividadeService
                .findAll(0, 50, searchQuery)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.id,
                            label: i.descricao,
                        };
                    });
                })
                .then((atividades) => {
                    this.atividadeSelect = Object.assign(atividades);
                    this.atividadeSelect.sort();
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de atividades. Termo: [${searchQuery}]`,
                        e
                    );
                })
                .finally(() => {
                    this.removeFromRequestQueue('atividades');
                });
        },
        loadAtividadeById() {
            if (this.cliente.idAtividade != null) {
                this.atividadeService
                    .find(this.cliente.idAtividade)
                    .then((atividade) => {
                        this.atividadeSelected = {
                            id: atividade.content.id,
                            label: atividade.content.descricao,
                        };
                    })
                    .catch((e) => {
                        console.error(
                            `Erro ao realizar pesquisa de atividades. Termo: [${searchQuery}]`,
                            e
                        );
                    });
            }
        },
        loadSituacao(search = '.*') {
            this.requestQueue.push('situacao');
            this.situacaoService
                .findAllVendas('descricao', 'asc', 0, 100, 1, search)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idsituacao,
                            label: m.descricao,
                        };
                    });
                })
                .then((value) => {
                    this.situacaoSelect = value;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os acertos.');
                })
                .finally((_) => {
                    if (this.situacaoSelect.length > 0 && this.cliente.idSituacao != null) {
                        this.situacaoSelected = this.situacaoSelect.filter(
                            (f) => f.id == this.cliente.idSituacao
                        )[0];
                    }
                    this.removeFromRequestQueue('situacao');
                });
        },
        loadRegiao() {
            this.requestQueue.push('regiao');
            this.regiaoService
                .findAllCombo('')
                .then((body) => {
                    return body.content.map((i) => {
                        return { id: i.id, label: i.descricao };
                    });
                })
                .then((regioes) => {
                    this.regiaoSelect = Object.assign(regioes);
                    this.regiaoSelect.sort();
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    if (
                        this.regiaoSelect.length > 0 &&
                        this.cliente.idRegiao != null &&
                        this.cliente.idRegiao != 0
                    ) {
                        this.regiaoSelected = this.regiaoSelect.filter(
                            (f) => f.id == this.cliente.idRegiao
                        )[0];
                    }
                    this.removeFromRequestQueue('regiao');
                });
        },
        loadRamo() {
            this.requestQueue.push('ramo');
            this.ramoService
                .findAllCombo('')
                .then((body) => {
                    return body.content.map((i) => {
                        return { id: i.id, label: i.descricao };
                    });
                })
                .then((ramos) => {
                    this.ramoSelect = Object.assign(ramos);
                    this.ramoSelect.sort();
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    if (
                        this.ramoSelect.length > 0 &&
                        this.cliente.idRamo != null &&
                        this.cliente.idRamo != 0
                    ) {
                        this.ramoSelected = this.ramoSelect.filter(
                            (f) => f.id == this.cliente.idRamo
                        )[0];
                    }
                    this.removeFromRequestQueue('ramo');
                });
        },
        loadMatriz() {
            this.requestQueue.push('matriz');
            this.clienteService
                .findAllCombo('')
                .then((body) => {
                    return body.content.map((i) => {
                        return { id: i.id, label: i.nome };
                    });
                })
                .then((matrizes) => {
                    this.matrizSelect = Object.assign(matrizes);
                    this.matrizSelect.sort();
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    if (this.$route.params.id) {
                        // remove a própria empresa da listagem, pois a mesma não pode ser matriz dela mesma
                        this.matrizSelect.splice(
                            this.matrizSelect.findIndex((fi) => fi.id == this.$route.params.id),
                            1
                        );
                    }
                    if (
                        this.matrizSelect.length > 0 &&
                        this.cliente.idMatriz != null &&
                        this.cliente.idMatriz != 0
                    ) {
                        this.matrizSelected = this.matrizSelect.filter(
                            (f) => f.id == this.cliente.idMatriz
                        )[0];
                    }
                    this.removeFromRequestQueue('matriz');
                });
        },
        loadTransportadora() {
            this.requestQueue.push('transportadora');
            this.transportadoraService
                .findAllCombo('')
                .then((body) => {
                    return body.content.map((i) => {
                        return { id: i.id, label: i.nome };
                    });
                })
                .then((transportadoras) => {
                    this.transportadoraSelect = Object.assign(transportadoras);
                    this.transportadoraSelect.sort();
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    if (this.$route.params.id) {
                        // remove a própria empresa da listagem, pois a mesma não pode ser transportadora dela mesma
                        this.transportadoraSelect.splice(
                            this.transportadoraSelect.findIndex(
                                (fi) => fi.id == this.$route.params.id
                            ),
                            1
                        );
                    }
                    if (
                        this.transportadoraSelect.length > 0 &&
                        this.cliente.idTransportadora != null &&
                        this.cliente.idTransportadora != 0
                    ) {
                        this.transportadoraSelected = this.transportadoraSelect.filter(
                            (f) => f.id == this.cliente.idTransportadora
                        )[0];
                    }
                    this.removeFromRequestQueue('transportadora');
                });
        },
        loadVendedores(search) {
            this.requestQueue.push('vendedores');
            if (isNull(search)) {
                search = ".*";
            }
            this.leadsService
                .getVendedores(search)
                .then((body) => {
                    return body.content.map((i) => {
                        return { id: i.id, label: i.nome };
                    });
                })
                .then((vendedor) => {
                    this.vendedorSelect = Object.assign(vendedor);
                    this.vendedorSelect.sort();
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    this.removeFromRequestQueue('vendedores');
                    if (this.clienteExistente) this.loadVendedorVinculado(this.idClienteExistente);
                });
        },
        loadVendedorVinculado(search) {
            this.requestQueue.push('vendedor-vinculado');
            this.leadsService
                .getVendedor(this.idClienteExistente, search)
                .then((body) => {
                    if (body.status == 200) {
                        this.vendedorSelected = this.vendedorSelect.filter(
                            (f) => f.id == body.content
                        )[0];
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.removeFromRequestQueue('vendedor-vinculado');
                });
        },
        loadGrupoEconomico() {
            this.requestQueue.push('grupoeconomico');
            this.grupoEconomicoService
                .findAllCombo('')
                .then((body) => {
                    return body.content.map((i) => {
                        return { id: i.id, label: i.descricao };
                    });
                })
                .then((gruposeconomicos) => {
                    this.grupoEconomicoSelect = Object.assign(gruposeconomicos);
                    this.grupoEconomicoSelect.sort();
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    if (
                        this.grupoEconomicoSelect.length > 0 &&
                        this.cliente.idGrupoEconomico != null &&
                        this.cliente.idGrupoEconomico != 0
                    ) {
                        this.grupoEconomicoSelected = this.grupoEconomicoSelect.filter(
                            (f) => f.id == this.cliente.idGrupoEconomico
                        )[0];
                    }
                    this.removeFromRequestQueue('grupoeconomico');
                });
        },
        loadCidade(cidade, uf = null) {
            this.requestQueue.push('cidade');
            this.cidadeService
                .findAll(0, 100, cidade ? cidade : '')
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.idcidade,
                            cidade: i.cidade,
                            nome: i.descricao,
                            estado: i.estado.descricao,
                        };
                    });
                })
                .then((allcidades) => {
                    this.cidadeSelect = Object.assign(allcidades);
                    this.cidadeSelect.sort();
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    // foi colocado aqui para a busca com cep funcionar até com conexão fraca a internet
                    if (!this.isNull(this.buscaCep)) {
                        let idCidade = this.cidadeSelect.filter(
                            (s) => s.estado == this.buscaCep.uf
                        );
                        if (idCidade.length > 0) {
                            this.loadCidadeById(idCidade[0].id);
                        } else {
                            this.msgs.push(new Message('alert', 'cidade-nao-encontrada', true));
                        }
                        this.buscaCep = null;
                    } else if (uf != null) {
                        let idCidade = this.cidadeSelect.filter((s) => s.estado == uf);
                        if (idCidade.length > 0) {
                            this.loadCidadeById(idCidade[0].id);
                        }
                    }
                    this.removeFromRequestQueue('cidade');
                });
        },
        loadCidadeById(id) {
            this.cidadeService
                .find(id)
                .then((cidade) => {
                    if (cidade.content != null) {
                        let temp = {
                            id: cidade.content.id,
                            nome: cidade.content.descricao,
                            estado: cidade.content.estado.descricao,
                            cidade: cidade.content.cidade,
                        };
                        this.cidadeSelected = temp;
                    } else {
                        console.warn('Busca de cidade vazia');
                    }
                }, 350)
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {});
        },
        updateCidade() {
            this.cliente.idCidade = this.cidadeSelected != null ? this.cidadeSelected.id : null;
            if (
                !this.isNull(this.cliente.ierg) &&
                this.pessoaSelected.id == 1 &&
                this.estrangeiroSelected.id == 0 &&
                this.contribuinteSelected.id != 'I'
            ) {
                this.customValidations('ierg');
            }
        },
        copyToWhatsApp() {
            this.copyToWhatsAppActive = true;
            this.cliente.fax = this.cliente.celular;
            this.validadeByPdaDetalhe('fax');
            setTimeout(() => {
                this.copyToWhatsAppActive = false;
            }, 50);
        },
        copyEmail() {
            this.cliente.emailNfe = this.cliente.email;
            this.validadeByPdaDetalhe('emailnfe');
        },
        openLocationEditor() {
            if (
                !this.onlyNumbers(this.cliente.latitude) ||
                !this.onlyNumbers(this.cliente.longitude)
            ) {
                this.center.lat = 0;
                this.center.lng = 0;
            } else {
                this.center.lat = +this.cliente.latitude;
                this.center.lng = +this.cliente.longitude;
            }
            if (
                this.isNull(this.cliente.latitude) &&
                this.isNull(this.cliente.longitude) &&
                !this.isNull(this.cidadeSelected)
            ) {
                if (!this.isNull(this.cliente.endereco))
                    this.startSearchWith = this.cliente.endereco;
                if (!this.isNull(this.cliente.numero))
                    this.startSearchWith = this.startSearchWith + ' ' + this.cliente.numero;
                if (!this.isNull(this.cliente.bairro))
                    this.startSearchWith = this.startSearchWith + ' ' + this.cliente.bairro;
                if (!this.isNull(this.cidadeSelected.cidade))
                    this.startSearchWith = this.startSearchWith + ' ' + this.cidadeSelected.cidade;
                if (!this.isNull(this.cidadeSelected.estado))
                    this.startSearchWith = this.startSearchWith + ' ' + this.cidadeSelected.estado;
                setTimeout(() => {
                    this.$children[this.$children.length - 1].getLocation(this.startSearchWith);
                }, 1000);
            }
            this.locationEditorOpen = true;
        },
        onCancelLocationEditor() {
            this.locationEditorOpen = false;
            this.startSearchWith = '';
        },
        updateLocation(val) {
            this.center.lat = val.center.lat;
            this.center.lng = val.center.lng;
            this.cliente.latitude = this.center.lat;
            this.cliente.longitude = this.center.lng;
            this.onCancelLocationEditor();
            this.validadeByPdaDetalhe('latitude');
            this.validadeByPdaDetalhe('longitude');
        },
        //funções para fechamento do modal, selecionam o valor adicionado no banco pelo modal
        fecharModalRegiaoWithValue(data = null) {
            if (data != null) {
                let tempRegiao = { id: data.idregiao, label: data.descricao };
                this.regiaoSelect.push(tempRegiao);
                this.regiaoSelected = tempRegiao;
                this.isChanged = true;
            }
            this.showModalCadastroRegiao = false;
        },
        fecharModalSituacaoWithValue(data = null) {
            if (data != null) {
                let tempSituacao = { id: data.idsituacao, label: data.descricao };
                this.situacaoSelect.push(tempSituacao);
                this.situacaoSelected = tempSituacao;
                this.isChanged = true;
            }
            this.showModalCadastroSituacao = false;
        },
        fecharModalGrupoEconomico(data = null) {
            if (data != null) {
                let tempGrupoEconomico = { id: data.id, label: data.descricao };
                this.grupoEconomicoSelect.push(tempGrupoEconomico);
                this.grupoEconomicoSelected = tempGrupoEconomico;
                this.isChanged = true;
            }
            this.showModalCadastroGrupoEconomico = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
    .sem-margem-bottom {
        .columns:last-child {
            margin-bottom: 0;
        }
    }
    .botao-localizacao {
        margin-top: 15px;
        width: max-content;
    }
    @media (max-width: 1280px) {
        .botao-localizacao {
            font-size: 10px;
        }
    }
}
.icone-texto {
    display: flex;
    flex-direction: row;
    align-items: center;
}
</style>
